import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputNumbersmall, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { errorStyles } from '../../Utils/table';
import { fetchStitchContraRegister2, StitchingReturns } from '../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchContraRegister } from '../Selectors/StitchSelector/StitchingSelectors';
import Dropdown from '../FieldsComponents/Dropdown';


const StitchContReturn2 = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        stId: '',
        dt: '',
        stMemo: '',
        ctMemo: '',
        reMemo: '',
        empType: '2',
        empId: '',
        empNm: '',
        itemId: '',
        itemNm: '',
        sono: '',
        soId: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        totQty: '',
        instruction: '',
        reQty: '',
        kaje_sts: '',
        totmat: '',
        totmatuse: '',
        totmatbal: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const stitchlist = useSelector(selectStitchContraRegister);

    // var itemData = stitchlist?.Info?.length > 0 ? {
    //     size: stitchlist.Info.map(val => val.size),
    //     ctqty: stitchlist.Info.map(val => parseFloat(val.ctqty)),
    //     issqty: stitchlist.Info.map(val => parseFloat(val.issqty)),
    //     balqty: stitchlist.Info.map(val => parseFloat(val.balqty)),
    // } : [];

    const [itemData, setItemData] = useState([]);
    const [itemlist, setItemlist] = useState([]);
    const [stitchData, setStitchData] = useState([]);
    const [material, setMaterial] = useState([]);
    const [returnQtyValues, setReturnQtyValues] = useState(Array(itemData?.size?.length).fill(''));
    const [damageQtyValues, setDamageQtyValues] = useState(Array(itemData?.size?.length).fill(''));
    const [balQtyValues, setBalQtyValues] = useState(Array(itemData?.size?.length).fill(''));
    const [countId, setCountId] = useState(0);

    useEffect(() => {
        dispatch(fetchStitchContraRegister2(Id));
    }, [dispatch, Id]);


    useEffect(() => {
        if (stitchlist?.itemlist?.length > 0) {
            const values = stitchlist?.itemlist;
            setItemlist(values);
        }
        if (stitchlist?.data) {
            const datas = stitchlist?.data;
            const count = stitchlist?.stIdCount;
            setStitchData(datas);
            setCountId(count);
        }
    }, [stitchlist]);

    // console.log(stitchlist);

    useEffect(() => {
        if (returnQtyValues.length > 0) {
            const reqtytotal = returnQtyValues.reduce((sum, qty) => sum + parseFloat(qty), 0);

            setFormData(prev => ({
                ...prev,
                reQty: reqtytotal || 0,
            }));
        }
    }, [returnQtyValues]);

    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'itemId':
                if (value) {
                    const item = stitchData?.find(item => item.itemId === value);
                    // console.log(selectdata);
                    if (item) {
                        // const item = parseFloat(selectdata.count) + 1;
                        const reCount = parseFloat(countId) + 1;

                        // const item = selectdata?.cloths[0];
                        setFormData(prev => ({
                            ...prev,
                            stMemo: item.stMemo,
                            ctMemo: item.ctMemo,
                            reMemo: reCount !== 1 ? `R-${item.stMemo}-${reCount}` : `R-${item.stMemo}`,
                            totQty: item.totQty,
                            instruction: item.instruction,
                            empId: item.empId,
                            empNm: item.empNm,
                            itemId: item.itemId,
                            itemNm: item.itemNm,
                            soId: item.soId,
                            sono: item.sono,
                            mcloth: item.mcloth || '',
                            mclothNm: item.mclothNm || '',
                            m1cloth: item.m1cloth || '',
                            m1clothNm: item.m1clothNm || '',
                            m2cloth: item.m2cloth || '',
                            m2clothNm: item.m2clothNm || '',
                            m3cloth: item.m3cloth || '',
                            m3clothNm: item.m3clothNm || '',
                            stId: item.ID
                        }));

                        const array = item?.stInfo?.length > 0 ? {
                            size: item?.stInfo?.map(val => val.size),
                            ctqty: item?.stInfo?.map(val => parseFloat(val.ctqty)),
                            issqty: item?.stInfo?.map(val => parseFloat(val.issqty)),
                            balqty: item?.stInfo?.map(val => parseFloat(val.balqty)),
                            qty: item?.stInfo?.map(val => parseFloat(val.balqty)),
                            rqty: item?.stInfo?.map(() => 0),
                            dqty: item?.stInfo?.map(() => 0),
                        } : [];
                        setItemData(array);

                        const value = JSON.parse(JSON.stringify(item?.stInfo2));
                        setMaterial(value);
                        const matqty = value?.reduce((acc, qty) => acc + parseFloat(qty.balqty), 0);
                        setFormData(prev => ({
                            ...prev,
                            totmat: matqty
                        }));
                    }
                } else {
                    setFormData(prev => ({
                        ...prev,
                        empNm: '',
                        empId: '',
                        empType: '',
                        item: '',
                        itemId: '',
                        cutMemo: '',
                        reMemo: '',
                        soId: '',
                        sono: '',
                        totQty: '',
                        mcloth: '',
                        mclothNm: '',
                        m1cloth: '',
                        m1clothNm: '',
                        m2cloth: '',
                        m2clothNm: '',
                        m3cloth: '',
                        m3clothNm: '',
                        mgmtr: '',
                        m1gmtr: '',
                        m2gmtr: '',
                        m3gmtr: ''
                    }));
                }
                break;
            default:
                break;
        }
    };

    const handleRemainChange = (e) => {
        const { name, value } = e.target;
        switch (name) {
            case 'mRmtr':
                let main_used = parseInt(formData.mgmtr) - parseInt(value);
                setFormData(prev => ({
                    ...prev,
                    mused: main_used,
                    mRmtr: value
                }));
                break;
            case 'm1Rmtr':
                let m1_used = parseInt(formData.m1gmtr) - parseInt(value);
                setFormData(prev => ({
                    ...prev,
                    m1used: m1_used,
                    m1Rmtr: value
                }));
                break;
            case 'm2Rmtr':
                let m2_used = parseInt(formData.m2gmtr) - parseInt(value);
                setFormData(prev => ({
                    ...prev,
                    m2used: m2_used,
                    m2Rmtr: value
                }));
                break;
            case 'm3Rmtr':
                let m3_used = parseInt(formData.m3gmtr) - parseInt(value);
                setFormData(prev => ({
                    ...prev,
                    m3used: m3_used,
                    m3Rmtr: value
                }));
                break;
            default:
                break;
        }
    }
    const handleQtyChange = (type, index, value) => {
        let newReturnQtyValues = [...itemData.rqty];
        let newDamageQtyValues = [...itemData.dqty];
        let newBalQtyValues = [...itemData.balqty];

        // Ensure the input value is a number and not greater than the Issue Qty
        const issueQty = itemData.qty[index];
        let enteredValue = parseInt(value) || 0; // default to 0 if invalid input

        switch (type) {
            case 'return':
                // Return Qty should not exceed Issue Qty
                if (enteredValue <= issueQty) {
                    newReturnQtyValues[index] = enteredValue;
                } else {
                    alert('Return Qty should not exceed Issue Qty.');
                    newReturnQtyValues[index] = issueQty;
                }
                break;

            case 'damage':
                const currentReturnQty = newReturnQtyValues[index] || 0;
                const availableQty = issueQty - currentReturnQty;

                // Damage Qty should not exceed available Qty after Return
                if (enteredValue <= issueQty) {
                    newDamageQtyValues[index] = enteredValue;
                } else {
                    alert('Damage Qty exceeds available balance.');
                    newDamageQtyValues[index] = availableQty;
                }
                if (currentReturnQty === itemData.balqty[index]) {
                    let update_returnqty = currentReturnQty - parseFloat(enteredValue);
                    newReturnQtyValues[index] = update_returnqty;
                }
                break;

            default:
                console.warn(`Unhandled type: ${type}`);
                break;
        }

        // Calculate Bal Qty (Issue Qty - Return Qty - Damage Qty)
        let balQty_updates = issueQty - (newReturnQtyValues[index] || 0) - (newDamageQtyValues[index] || 0);
        newBalQtyValues[index] = balQty_updates > 0 ? balQty_updates : 0;

        // Update state
        // setReturnQtyValues(newReturnQtyValues);
        // setDamageQtyValues(newDamageQtyValues);
        // setBalQtyValues(newBalQtyValues);

        setItemData(prev => ({
            ...prev,
            rqty: newReturnQtyValues,
            dqty: newDamageQtyValues,
            balqty: newBalQtyValues
        }));
    };


    const handleRemainQtyChange = (e, index) => {
        const newRemainQty = Number(e.target.value);
        const updatedMaterials = [...material];

        // Ensure the remain qty is not greater than balqty
        if (newRemainQty > updatedMaterials[index].balqty) {
            alert('Remain Quantity cannot be greater than Balance Quantity');
            return; // Exit if the remain qty is invalid
        }

        // Update the remain qty and calculate use qty (balqty - remainqty)
        updatedMaterials[index].useqty = newRemainQty;
        updatedMaterials[index].remainqty = updatedMaterials[index].balqty - newRemainQty;

        setMaterial(updatedMaterials);

        const totusedqty = updatedMaterials?.reduce((acc, use) => acc + parseFloat(use.useqty || 0), 0);
        const totbalqty = updatedMaterials?.reduce((acc, bal) => acc + parseFloat(bal.remainqty || 0), 0);
        setFormData(prev => ({
            ...prev,
            totmatbal: totbalqty,
            totmatuse: totusedqty
        }));
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };



    function convertIntoOneObject(formData, itemData, material) {
        const data = {
            stId: formData.stId,
            dt: formData.dt,
            reMemo: formData.reMemo,
            stMemo: formData.stMemo,
            soId: formData.soId,
            empId: formData.empId,
            empType: formData.empType,
            itemId: formData.itemId,
            mcloth: formData.mcloth,
            m1cloth: formData.m1cloth || '0',
            m2cloth: formData.m2cloth || '0',
            m3cloth: formData.m3cloth || '0',
            totQty: formData.totQty || '0',
            reQty: formData.reQty || '0',
            size: itemData.size,
            issqty: itemData.issqty,
            rqty: itemData.rqty,
            dqty: itemData.dqty,
            balqty: itemData.balqty,
            kaje_sts: formData.kaje_sts,
            userId: formData.userId,
            material: material,
            totmat: formData.totmat,
            remat: formData.totmatuse
        }
        return data;
    }
    const fields = [
        { label: 'Stitch Memo No.', name: 'stMemo' },
        { label: 'Master', name: 'empNm' },
    ];

    const fields2 = [
        { label: 'Main Cloth', name: 'mclothNm' },
    ];



    const handleSubmit = async (e) => {
        e.preventDefault();


        if (!formData.dt || formData.dt.trim() === '') {
            alert("Date is required.");
            return; // Stop the submission if validation fails
        }
        setLoading(true);

        try {
            const finalObject = convertIntoOneObject(formData, itemData, material);
            // console.log(finalObject);

            const result = await dispatch(StitchingReturns(finalObject)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Stitching Return Added");
            alert("Stitching Return Added");
            window.close();

            // if (window.confirm("Your data has been submitted successfully. Do you want to close this tab?")) {
            //     window.close();
            // }

        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }
    };

    const dropdownlist = [
        {
            label: 'Item',
            id: 'itemId',
            options: itemlist || [],
            value: formData.itemId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];


    return (
        <>

            <div style={{ margin: '1%' }}>
                <h2>Stitching(Contractor) Return Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Return Memo', name: 'reMemo', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {
                                    dropdownlist && dropdownlist.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {formData.soId !== '0' && formData.soId !== '' &&
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='sono'>Sale Order No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {/* Replace TextField with Typography to display plain text */}
                                                    <Typography
                                                        id='sono'

                                                    >
                                                        {formData.sono || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors.sono && <FormHelperText style={errorStyles}>{errors.sono}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                {fields?.map((field) => (
                                    <Grid item xs={12} md={6} key={field.name}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id={field.name}
                                                    >
                                                        {formData[field.name] || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='totQty'>Issue Qty.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='totQty'

                                                >
                                                    {formData.totQty || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='reQty'>Return Qty.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='reQty'

                                                >
                                                    {formData.reQty || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {formData.soId === '0' &&

                                    <Grid item xs={12} md={6}>

                                    </Grid>

                                }

                                {fields2.map((field) => (
                                    <Grid item xs={12} md={6} key={field.name}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Typography
                                                        id={field.name}
                                                    >
                                                        {formData[field.name] || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}




                                {formData.m1cloth !== '0' && formData.m1cloth !== '' &&
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m1clothNm'>M-1 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m1clothNm'

                                                        >
                                                            {formData.m1clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>
                                                        {errors.m1clothNm && <FormHelperText style={errorStyles}>{errors.m1clothNm}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </>

                                }


                                {formData.m2cloth !== '0' && formData.m2cloth !== '' &&

                                    <>
                                        <Grid item xs={12} md={6}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m2clothNm'>M-2 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m2clothNm'

                                                        >
                                                            {formData.m2clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>
                                                        {errors.m1clothNm && <FormHelperText style={errorStyles}>{errors.m1clothNm}</FormHelperText>}
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>

                                }


                                {formData.m3cloth !== '0' && formData.m3cloth !== '' &&

                                    <>
                                        <Grid item xs={12} md={6}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m3clothNm'>M-3 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m3clothNm'

                                                        >
                                                            {formData.m3clothNm || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </>
                                }

                                {formData.ctMemo !== '' &&
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                                    )) : null}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                                    {itemData?.qty ? itemData?.qty?.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                                    )) : null}
                                                </TableRow>

                                                {/* Return Qty Row */}
                                                {/* <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Return Qty.</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={returnQtyValues[index]}
                                                                onChange={(e) => {
                                                                    // Update the value on change
                                                                    const newValues = [...returnQtyValues];
                                                                    newValues[index] = e.target.value;
                                                                    setReturnQtyValues(newValues); // Assuming you have this state setter function
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                                                        handleQtyChange('return', index, e.target.value);
                                                                    }
                                                                }}

                                                                placeholder='0'
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow> */}


                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Return Qty.</TableCell>
                                                    {itemData?.rqty ? itemData?.rqty?.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={val}
                                                                onChange={(e) => handleQtyChange('return', index, e.target.value)}
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>

                                                {/* Damage Qty Row */}
                                                {/* <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Damage Qty.</TableCell>
                                                    {itemData.size ? itemData.size.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={damageQtyValues[index]}
                                                                onChange={(e) => {
                                                                    // Update the value on change
                                                                    const newValues = [...damageQtyValues];
                                                                    newValues[index] = e.target.value;
                                                                    setDamageQtyValues(newValues); // Assuming you have this state setter function
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                                                        handleQtyChange('damage', index, e.target.value);
                                                                    }
                                                                }}

                                                                placeholder='0'
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow> */}

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Damage Qty.</TableCell>
                                                    {itemData?.dqty ? itemData?.dqty?.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            <input
                                                                type="text"
                                                                style={{ width: '40px', padding: '1px' }}
                                                                value={val}
                                                                onChange={(e) => handleQtyChange('damage', index, e.target.value)}
                                                            />
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Bal Qty.</TableCell>
                                                    {itemData?.balqty ? itemData?.balqty?.map((val, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>
                                                            {val}
                                                        </TableCell>
                                                    )) : null}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }



                                <Grid item xs={12} md={6}>
                                    <div>
                                        <table style={{ width: '80%', margin: '1% 5%' }}>
                                            <thead>
                                                <tr>
                                                    <th>Sr. No.</th>
                                                    <th>Material Work</th>
                                                    <th>Given Qty</th>
                                                    <th>Used Qty</th>
                                                    <th>Bal Qty</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {material?.map((mat, matIndex) => (
                                                    <>
                                                        <tr key={matIndex}>
                                                            <td>
                                                                {matIndex + 1}
                                                            </td>
                                                            <td>
                                                                {mat.materialNm}
                                                            </td>
                                                            <td>
                                                                {mat.balqty}
                                                            </td>
                                                            <td>
                                                                {/* {mat.useqty} */}
                                                                <input
                                                                    type="text"
                                                                    placeholder="0"
                                                                    value={mat.useqty}
                                                                    onChange={(e) => handleRemainQtyChange(e, matIndex)}
                                                                    style={{ width: '60px' }}
                                                                />
                                                            </td>
                                                            <td>
                                                                {/* <input
                                                                type="text"
                                                                placeholder="0"
                                                                value={mat.remainqty}
                                                                onChange={(e) => handleRemainQtyChange(e, matIndex)}
                                                                style={{ width: '60px' }}
                                                            /> */}
                                                                {mat.remainqty}
                                                            </td>
                                                        </tr>
                                                    </>
                                                ))}
                                                <tr>
                                                    <td> </td>
                                                    <td>
                                                        <span className="tot-lump">Total Qty</span>
                                                    </td>
                                                    <td>
                                                        <span className="tot-lump">{formData.totmat}</span>
                                                    </td>
                                                    <td>
                                                        <span className="tot-lump">{formData.totmatuse}</span>
                                                    </td>
                                                    <td>
                                                        <span className="tot-lump">{formData.totmatbal}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StitchContReturn2;
